import OrionError from '../error/OrionError'
import type { Ref } from 'vue'

import type { CodeData } from '../components/types'

export interface ThroneType {
  getCode: (codeName: string, context?: Record<string, any>) => Ref<CodeData>
  impl: (throne: Partial<ThroneType>) => void
}

let getCode: ThroneType['getCode'] = (codeName) => {
  throw new OrionError(`Throne.getCode not configured!`)
}

const Throne: ThroneType = {
  getCode: (codeName, context?: Record<string, any>) => {
    return getCode(codeName, context)
  },
  impl: (throne) => {
    if (throne.getCode) {
      getCode = throne.getCode
    }
  },
}

export default Throne
